import { Button, buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { faArrowLeft, faPlusLarge } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { KalenderCard } from '@/domain/termine/features/TerminKalender/Mobile/Card/KalenderCard';
import { KalenderCardEmpty } from '@/domain/termine/features/TerminKalender/Mobile/Card/KalenderCardEmpty';
import { useTerminKalenderList } from '@/domain/termine/hooks/useTerminKalenderList';
import { useState } from 'react';
import { CreateTerminKalenderDrawer } from '@/domain/termine/features/CreateTerminKalender/Drawer/CreateTerminKalenderDrawer';

function KalenderMobileHeader() {
  const { t } = useTranslation();

  return (
    <div className="sticky top-0 z-10 bg-neutrals-200">
      <div className="flex items-start justify-between p-4">
        <div className="flex items-center gap-2">
          <Link
            to="/termine/uebersicht"
            aria-label={t('domain.termine.title')}
            title={t('domain.termine.title')}
            className={cn(buttonVariants({ variant: 'ghost', size: 'icon' }))}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </Link>
          <span className="font-semibold text-sm">
            {t('domain.termine.title')}
          </span>
        </div>
      </div>
    </div>
  );
}

export function KalenderMobileContent() {
  const { t } = useTranslation();
  const { kalender } = useTerminKalenderList();
  const filteredData = kalender.filter((row) => row.kalenderSchluessel !== -1);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <div className="relative pb-20">
        <KalenderMobileHeader />
        <div className="px-4 flex flex-col gap-3">
          <span className="text-xl font-bold">
            {t('domain.termine.createTitle')}
          </span>
          {filteredData.length === 0 ? (
            <KalenderCardEmpty />
          ) : (
            filteredData.map((kalender) => (
              <KalenderCard key={kalender.id} kalender={kalender} />
            ))
          )}
        </div>
        <div className="fixed right-4 bottom-4 z-20">
          <Button
            variant="default"
            size="icon"
            className="mt-2"
            onClick={() => setDrawerOpen(true)}>
            <FontAwesomeIcon icon={faPlusLarge} className="font-bold" />
          </Button>
        </div>
      </div>
      {drawerOpen && (
        <CreateTerminKalenderDrawer onOpenChange={setDrawerOpen} />
      )}
    </>
  );
}
